// Empty strings are meaningful, so we have to look at each property and
// check for null and undefined only, returns boolean, true if no data,
// false if data
export default obj => Object.keys(obj).filter(key => obj[key] !== null && obj[key] !== undefined).length > 0;
